import { gql } from "@apollo/client";

const GET_CONSIGNMENT_DOCUMENT_UPLOAD_URLS = gql`
  query GetConsignmentDocumentUploadUrls(
    $input: GetConsignmentDocumentUploadUrlsInput!
  ) {
    getConsignmentDocumentUploadUrls(input: $input) {
      success
      error
      urls {
        url
        key
        filename
      }
    }
  }
`;

export { GET_CONSIGNMENT_DOCUMENT_UPLOAD_URLS };
